import Link from 'next/link';
import { Info } from 'phosphor-icons';
import { LinkV2 } from '../../atoms/Link/Link.v2';
import { Popover } from '../../atoms/Popover/Popover';
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../molecules/Table/Table';
import { PackageCompatibilityTableProps } from './PackageCompatibilityTable.types';

export const PackageCompatibilityTable = ({
  unityVersion,
  renderPipelines,
  buildTarget,
  microcopy,
  className,
}: PackageCompatibilityTableProps) => {
  return (
    <Table className={className} role="presentation">
      <TableCaption>{microcopy.title}</TableCaption>

      <TableHeader className="sr-only">
        <TableRow>
          <TableHead>{microcopy.headerColumn1}</TableHead>
          <TableHead>{microcopy.headerColumn2}</TableHead>
        </TableRow>
      </TableHeader>

      <TableBody variant="alternate">
        <TableRow>
          <TableHead scope="row" className="!align-top">
            {microcopy.unityVersion}
          </TableHead>
          <TableCell className="w-44 break-normal">
            {unityVersion.join(', ')}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableHead scope="row" className="!align-top">
            <div className="inline-flex items-center">
              <p className="tiny-text text-grey-700">
                {microcopy.renderPipelines}
              </p>
              <Popover>
                <Popover.Trigger
                  aria-label={microcopy.renderPipelinesTooltip}
                  className="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-grey-500 hover:text-grey-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue focus-visible:ring-offset-1 focus-visible:ring-offset-white"
                >
                  <Info size={16} weight="regular" aria-hidden="true" />
                </Popover.Trigger>
                <Popover.Content className="w-64 rounded-md border-transparent bg-grey-700 px-4 py-3 text-white shadow-card [&>div:nth-child(1)]:hidden [&>div:nth-child(2)]:hidden">
                  <div
                    aria-hidden="true"
                    className="absolute -top-1 left-1/2 h-3 w-3 -translate-x-1/2 rotate-45 bg-grey-700"
                  />
                  <p className="text-sm leading-7 text-white">
                    {microcopy.renderPipelinesTooltip}
                  </p>
                  <LinkV2 asChild size="small">
                    <Link
                      href={microcopy.renderPipelinesTooltipLinkHref}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm leading-7 text-blue-300 no-underline hover:text-blue-200 hover:no-underline"
                    >
                      {microcopy.renderPipelinesTooltipLinkLabel}
                    </Link>
                  </LinkV2>
                </Popover.Content>
              </Popover>
            </div>
          </TableHead>
          <TableCell>{renderPipelines.join(', ')}</TableCell>
        </TableRow>
        <TableRow>
          <TableHead scope="row" className="!align-top">
            {microcopy.buildTarget}
          </TableHead>
          <TableCell>{buildTarget.join(', ')}</TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};
